import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import './PageFooter.scss';
import PmcSignUpService from '../Service/PmcSignUpService';

function PageFooter() {
    const [footer, setFooter] = useState([]);
    let matchedLanguageFlag = useSelector((state) => state.users.matchedLanguageFlag);
    useEffect(() => {
        loadheader();
        const script = document.createElement('script');
        if (window.location.hostname === 'www.dell.com') {
            script.src = "https://nexus.dell.com/dell/stpfooter/Bootstrap.js";
        } else {
            script.src = "https://nexus.dell.com/dell/stpfooterdev/Bootstrap.js?v=11";
        }
        script.crossOrigin = 'anonymous';
        script.async = true;
        document.body.appendChild(script);
        const queryString = window.location.search;
        let country = '';
        let language = '';
        const urlParams = new URLSearchParams(queryString);
        country = urlParams.get('c');
        language = urlParams.get('l');
        if (language === '') {
            language = 'en';
        }
        else if (!language) {
            language = 'en';
        }

        if (country === '') {
            country = 'us';
        }
        else if (!country) {
            country = 'us';
        }
        let Dell = { ...window.Dell } || {};
        Dell.Metrics = Dell.Metrics || {};
        Dell.Metrics.sc = Dell.Metrics.sc || {};
        Dell.Metrics.sc.country = Dell.Metrics.sc.country || country;
        Dell.Metrics.sc.language = Dell.Metrics.sc.language || language;
        Dell.Metrics.sc.segment = Dell.Metrics.sc.segment || "corp";
        Dell.Metrics.sc.customerset = Dell.Metrics.sc.customerset || "19";
        Dell.Metrics.sc.cms = Dell.Metrics.sc.cms || "pmc";
        Dell.Metrics.sc.pagename = Dell.Metrics.sc.pagename || `${country}:${language}:dhs:pmc:pmcSignup`;
        Dell.Metrics.sc.applicationname = Dell.Metrics.sc.applicationname || "Transactional:PMC_Email_SignUp";
        window.Dell = { ...Dell };

    }, [matchedLanguageFlag]);

    const loadheader = async () => {
        PmcSignUpService.getFooter(matchedLanguageFlag).then((response) => {
            setFooter(response.data);
        });
    }

    return (
        <div className='pageFooter'>
            <div dangerouslySetInnerHTML={{ __html : footer }}>
            </div>
         </div>
    )
}

export default PageFooter;